import { _tableLogActivity } from "lib/Helper";
import Action from "./Action";
import { SettingOutlined } from "@ant-design/icons";
import { LabelYesNo } from "components/labels";

const columns = (action, modalForm, modalDelete) => [
  {
    title: 'No',
    dataIndex: 'rownum',
    sorter: false,
    width: '2%',
  }, {
    title: 'Nama',
    dataIndex: 'nama',
    sorter: false,
    render: (a, row) => <>{row.nama ? row.nama : "-"} - {row.inisial ? row.inisial : "-"}</>,
  }, {
    title: 'Tipe',
    dataIndex: 'tipe',
    sorter: false,
  }, {
    title: 'Perlu Disetujui',
    sorter: false,
    render: (a, row) => <LabelYesNo isActive={row.is_approve === "1" ? true : false} />,
  }, {
    title: 'Keterangan',
    dataIndex: 'keterangan',
    sorter: false,
  }, {
    title: <SettingOutlined />,
    align: "center",
    key: 'operation',
    width: '2%',
    render: (a, row) => <Action row={row} action={action} modalForm={modalForm} modalDelete={modalDelete}/>,
  },
  {
    title: 'LogActivity',
    key: 'logactivity',
    width: '10%',
    render: (a, row) => _tableLogActivity(row),
  },
];

export default columns